import React from 'react'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import { createCustomer, userSignUp, get_active_user } from 'actions/Auth'
import { userSignInCallback } from 'actions'
import { withApollo } from 'react-apollo'
import { Redirect } from 'react-router'
import { checkAuthentication, isSignUpComplete } from 'util/checkAuthentication'
import SpecialistDetails from '../components/SpecialistDetails'
import debug from 'debug'
import { LoginForm } from '../components/Login'
import AppMainContainer from './AppMainContainer'
import LoginContainer from './LoginContainer'
import CardLayout from 'components/CardLayout'
import IntlMessages from 'util/IntlMessages'

const signUpDebug = debug('linkgua:signup')

const allowCustomerSignUp = process.env.ALLOW_CUSTOMER_SIGNUP === 'true'
signUpDebug('allowCustomerSignUp env', allowCustomerSignUp)

const PartiallySignedUp = ({goToCustomerSignUp, goToSpecialistSignUp}) => (
  <AppMainContainer>
    <LoginContainer headerLabelId='signUp.completeSignUp'>
      <div>
        <div className="mb-4">
     {/*@todo oversæt*/}
          <h2><IntlMessages id={'signUp.completeSignUp.message'}/></h2>
        </div>
        <div className="mb-3">
          <Button className="text-uppercase" onClick={goToCustomerSignUp}><IntlMessages id={'signUp.completeSignUp.customer'}/></Button>
        </div>
        <div className="mb-3">
          <Button className="text-uppercase" onClick={goToSpecialistSignUp}><IntlMessages id={'signUp.completeSignUp.specialist'}/></Button>
        </div>
      </div>
    </LoginContainer>
  </AppMainContainer>
)

class SignUpCustomer extends React.Component {

  render () {
    const {authUser, createCustomer} = this.props
    if (checkAuthentication(authUser) && ! isSignUpComplete(authUser)) {
      signUpDebug('User authenticated but not created, creating one')
      createCustomer()
    }

    return isSignUpComplete(authUser)
      ? (<Redirect to={'/customer/dashboard'}/>)
      : null
  }
}

const SignUpSpecialist = () => {
  return <SpecialistDetails />
}

const openChat = (e) => {
  e.preventDefault()
  window.HubSpotConversations.widget.open()
}

const SignUpMessage = () =>
  <CardLayout columns={6} styleName={'mr-auto ml-auto'}>
    <div className="card-body body-text mb-0">
      <h1 className="text-center">Great to see you!</h1>
      <p>To create a profile, we need a few basic details.</p>
      <p>Basically, we need <b>contact details</b> and <b>a description of your language skills</b>.</p>
      <p>You can check out our <a href="https://specialists.lingoowl.com/faq"  target="_blank">FAQ</a> for the most common questions or <a href="" onClick={openChat}>catch us on the chat</a>.</p>
      <p>We care about your privacy, so <b>everything is stored securely</b></p>
    </div>
  </CardLayout>


class SignUp extends React.Component {

  constructor (props, context) {
    super(props, context)
    const {userSignInCallback, match} = this.props
    const linkguaTypeFromUrl = match.params.type
    if (location.hash) {
      userSignInCallback(location.hash, `/signup/${linkguaTypeFromUrl}`)
    }
  }

  render () {
    signUpDebug('render', location.pathname)

    const {match, auth, userSignUp, createCustomer, history} = this.props
    const userType = auth && auth.userType
    const type = match.params.type || userType
    const goToCustomerSignUp = () => history.push('/signup/customer')
    const goToSpecialistSignUp = () => history.push('/signup/specialist')

    const partiallySignedUpContent = (
      <PartiallySignedUp
        goToCustomerSignUp={goToCustomerSignUp}
        goToSpecialistSignUp={goToSpecialistSignUp}
      />
    )

    if ((!type || type === 'customer') && !allowCustomerSignUp) {
      signUpDebug('customer sign up not allowed in env, redirecting to specialist sign up', type)
      goToSpecialistSignUp()
      return null
    }

    if (!type) {
      signUpDebug('no profile type in params, asking for type')
      return partiallySignedUpContent
    }

    if (!checkAuthentication(auth.authUser)) {
      signUpDebug('User not authenticated, showing sign up login')
      return <AppMainContainer>
        {type === 'specialist' ? <SignUpMessage/> : null}
        <LoginForm renderAs='signUp' headerLabelId={`component.signUp.${type}.signUpHeader`} onAuthenticationRequested={(email) => { userSignUp(type, email) }}/>
      </AppMainContainer>
    }

    if (isSignUpComplete(auth)) {
      signUpDebug('Sign up complete, redirecting to `/`')
      return <Redirect to={'/'}/>
    }

    switch (type) {
      case 'customer':
        signUpDebug(`rendering customer signup component, ${type}<<===`)
        return <SignUpCustomer
          authUser={auth.authUser}
          createCustomer={createCustomer}
        />
      case 'specialist':
        signUpDebug(`rendering specialist signup component, ${type}<<===`)
        return <AppMainContainer><SignUpSpecialist /></AppMainContainer>
      default:
        return partiallySignedUpContent
    }
  }
}

const mapStateToProps = ({auth}) => {
  return {auth}
}

export default connect(mapStateToProps, {
  userSignUp,
  userSignInCallback,
  createCustomer,
  get_active_user
})(withApollo(SignUp))



// WEBPACK FOOTER //
// ./Linkgua/containers/SignUp.js